export default __webpack_public_path__ + "static/media/skins-mobile-grid.a0a38308.png";